import React from 'react';
import { connect } from 'react-redux';

import { updateCampaignAggregates, getFocusedCampaign } from '../../store/api/calls';

import NavBaseTemplate from '../templates/NavBaseTemplate';
import BaseForm from '../theme/forms/BaseForm';
import DataTable from '../theme/tables/DataTable';
import BaseModal from '../theme/modals/BaseModal';
import FeedbackTile from '../theme/modals/FeedbackTile';
import Moment from 'moment';
import api from '../../store/api/api';
import Input from '../theme/forms/Input';
import MFASetUpForm from '../subscreens/MFASetUpForm';

class CanvasserScreen extends React.Component {
  // static propTypes = {
  // 	cookies: instanceOf(Cookies).isRequired
  // };

  constructor(props) {
    super(props);

    this.state = {
      mfa_enabled: false,
      cell_phone: null,
      loading: false,
      error: false,
      error_msg: 'Error',
      success: false,
      configuring_fma: false,
    };

    this.formInputs = [
      {
        type: 'switch-left',
        title: 'Multi-Factor Enabled',
        dataKey: 'mfa_enabled',
      },
      {
        type: 'text',
        title: 'Phone Number',
        dataKey: 'cell_phone',
        placeholder: '+18185551234',
      },
    ];

    this.sendTimeout = null;
  }

  componentDidMount() {
    this.setState({ loading: true });
    api
      .get('/profiles/0/') //0 means get the profile of the user attached to the requesting security key
      .then((res) => {
        this.setState({
          mfa_enabled: res.data.profile.mfa_enabled,
          cell_phone: res.data.profile.cell_phone,
          loading: false,
        });
      })
      .catch(() => {
        this.set_error('There was a problem pulling your profile data.');
      });
  }

  phone_is_valid = (val) => {
    if (val.split('')[0] === '+') {
      val = val.slice(2);
    }
    var patt = /\d{10}/g; //ten digits
    return patt.test(val);
  };

  set_error = (msg) => {
    this.setState(
      {
        error: true,
        error_msg: msg,
      },
      () => setTimeout(() => this.setState({ error: false, error_msg: '' }), 1500)
    );
  };

  handleChange = (data) => {
    this.setState({ loading: true });
    api
      .patch('/profiles/0/', data)
      .then((res) => {
        this.setState({ loading: false, success: true, ...res.data }, () =>
          setTimeout(() => this.setState({ success: false }), 1500)
        );
      })
      .catch(() => {
        this.set_error('Something went wrong, and your change was not made');
      });
  };

  buildInputsWithPrepopulatedFields = (modelInstance) => (
    <div className={''}>
      {this.state.mfa_enabled && (
        <div className={'flx'}>
          <Input
            type="switch-left"
            title="Multi-Factor Enabled"
            checked={this.state.mfa_enabled}
            value={this.state.mfa_enabled}
            onChange={(val) => {
              this.handleChange({ mfa_enabled: false });
            }}
          />

          <p style={{ marginLeft: '2em' }}>
            <div className={'button'}>Reset Authentication (New/Lost Phone)</div>
          </p>
        </div>
      )}

      {!this.state.mfa_enabled && (
        <>
          <div className={'button'} onClick={() => this.setState({ configuring_mfa: true })}>
            Set up Multi Factor Authentication
          </div>
        </>
      )}
    </div>
  );

  render() {
    return (
      <NavBaseTemplate location={this.props.location} showAdmin={this.props.is_admin}>
        <h3 className={'primary-text'}>Manage Profile</h3>

        {this.buildInputsWithPrepopulatedFields()}

        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-asterisk fa-spin" style={{ marginRight: '15px' }} />
              Loading...
            </div>
          }
          visible={this.state.loading}
        />
        {/*use feedback tile icon, text, state*/}
        <FeedbackTile
          text={
            <div>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: '15px' }} />
              {this.state.error_msg}
            </div>
          }
          visible={this.state.error}
          classNames="danger"
        />

        <FeedbackTile
          text={
            <div>
              <i className="fas fa-check" style={{ marginRight: '15px' }} />
              Success!
            </div>
          }
          visible={this.state.success}
          classNames="success"
        />
        <BaseModal
          // className="alerts-modal"
          open={this.state.configuring_mfa}
          onClose={() => this.setState({ configuring_mfa: false })}
          center
        >
          <MFASetUpForm
            dispatchProfileChanges={this.handleChange}
            dismissModal={() => this.setState({ configuring_mfa: false })}
            onSetUpSucess={() => this.setState({ mfa_enabled: true })}
            config={{ mfa_configuration_uri: this.state.mfa_configuration_uri }}
          />
        </BaseModal>
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: state.session.campaigns,
  focusedCampaign: state.session.focusedCampaign,
  is_admin: state.permissions.is_admin,
});

export default connect(mapStateToProps)(CanvasserScreen);
